<script>
    import { rank } from "../Stores";
    import { getSpotsString } from "../Utils";
    export let institution;

    let spotIsInsideMargin = parseInt(institution.last_spot) < $rank;
    let n_spots = spotIsInsideMargin
        ? institution.n_spots_in_margin
        : institution.n_spots;

    let institutionName = institution.institution;

    function getSpotColor(last_spot) {
        if (parseInt(last_spot) < $rank) {
            return "text-neutral-400";
        }
        return "";
    }
</script>

<p class={`text-xs md:text-base ml-4 ${getSpotColor(institution.last_spot)}`}>
    {#if institution.last_spot === "99999"}
        {institutionName} (vaga sobrante)
    {:else}
        {institutionName}, {n_spots}
        {getSpotsString(n_spots)} (u.c. {institution.last_spot})
    {/if}
</p>
